import { SpaceEventAction } from "./types/spaceTypes";
import { HttpRequest } from "./utils/HttpRequest";

export default class Space {
  httpReq = new HttpRequest();
  //Services
  // El espacio sale del token: el operador solo puede validar contra el suyo.
  getSpaceEvents(token: string, date: string): Promise<any> {
    return this.httpReq.post(`ws-security/space/getSpaceEvents`, {
      token,
      date,
    });
  }

  // El QR viaja en el payload: el endpoint es `scanSpace`, no `scanSpaceQr`.
  scanSpace(token: string, qr: string): Promise<any> {
    return this.httpReq.post(`ws-security/space/scanSpace`, {
      token,
      qr,
    });
  }

  addSpaceEvent(token: string, who: string, action: SpaceEventAction): Promise<any> {
    return this.httpReq.post(`ws-security/space/addSpaceEvent`, {
      token,
      who,
      action,
    });
  }
}
